import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// scroll bar
import 'simplebar/src/simplebar.css';

// third-party
import { Provider as ReduxProvider } from 'react-redux';

// apex-chart
import 'assets/third-party/apex-chart.css';

// project import
import App from './App';
import { store } from 'store';
import reportWebVitals from './reportWebVitals';
import ErrorBoundaryWithNavigation from 'utils/ErrorBoundary';
import { installAuthStorageShim } from 'utils/authSession';

const clearLegacyAuthCookies = () => {
  ['user', 'role', 'loginMenu', 'confvalue', 'token', 'authenticated'].forEach((key) => {
    document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
};

installAuthStorageShim();
clearLegacyAuthCookies();

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <StrictMode>
    <ReduxProvider store={store}>
      <BrowserRouter basename="">
        <ErrorBoundaryWithNavigation>
          <App />
        </ErrorBoundaryWithNavigation>
      </BrowserRouter>
    </ReduxProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
